import React from 'react';
import { Box } from '@mui/material';
import { Bookmark } from 'lucide-react';

export interface SavedSearchThumbnailPlaceholderProps {
  /** Bookmark icon size in px. Defaults to 24 (the card thumbnail); use a smaller value in tight spots. */
  iconSize?: number;
}

/**
 * Placeholder shown in a saved search thumbnail when there is no image: a light-blue
 * fill with a centered bookmark icon. Fills its container, so drop it into a sized
 * `Thumbnail`'s `fallback`. Shared by the panel cards and the top-bar bookmark button.
 */
export function SavedSearchThumbnailPlaceholder({ iconSize = 24 }: SavedSearchThumbnailPlaceholderProps) {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#e1f5fe',
      }}
    >
      <Bookmark size={iconSize} color="#438ab6" strokeWidth={2} aria-hidden />
    </Box>
  );
}

export default SavedSearchThumbnailPlaceholder;
